module.exports = __webpack_public_path__ + "media/images/front/pc/article/doctor02-b733eeaf2babe41b04e6b32fba9e075b.png";